export const environment = {
  production: true,
  appConfigurationEnvironment: 'stage',
  useDevTools: true,
};
